export default __webpack_public_path__ + "static/media/pen.4bf3ccd7.svg";